import styled, { css } from 'styled-components';
import { LoaderSpinProps } from './LoaderSpin';

export const LoaderSpinWrapper = styled.div<LoaderSpinProps>`
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  align-self: stretch;
  padding: 20px;
  padding-bottom: 15px;
  margin-top: 1px;

  ${props =>
    props.hasFullWidthChildren &&
    css`
      .ant-spin-nested-loading {
        width: 100%;
        height: 100%;
      }
    `}
  ${props =>
    props.noPadding &&
    css`
      &&& {
        padding: 0;
      }
    `}

  ${props =>
    props.hasScroll &&
    css`
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      padding: 0;

      .ant-spin-nested-loading {
        width: 100%;
        height: 100%;
        .ant-spin-container {
          width: 100%;
          height: 100%;
        }
      }
    `};

  ${props =>
    props.full &&
    css`
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
    `};

  ${props =>
    props.transparent &&
    css`
      background: transparent;
    `}
`;
